import { Box, Typography, Button, List } from '@mui/material';
import React from 'react';
//import { useDeviceDetails } from '../../data/DataProviders/DeviceDetailsProvider';
import { sortObjectArrayNaturally } from '../../lib';
import { Status, isDataLoaded } from '../../types';
import AddIcon from '@mui/icons-material/Add';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import { pushAppRoute } from '../../data/domain/route-manager';
import { useHistory } from 'react-router-dom';
import { DataIndicators } from '../DataIndicators';
import { FlatListItem } from '../FlatListItem/FlatListItem';
//import { Device } from '../../api/types';
import { StarfishDevice } from '../../api/types';
//import { useSignalRSiteData } from '../../data/DataProviders/SignalRSiteDataProvider';
//import { getUpdatedChildDeviceStatusList } from '../../lib/signalr-helper';
import { useStarfishDeviceDetails } from '../../data/DataProviders/StarfishGatewayDeviceDetailsProvider';
export const StarFishChildDeviceList: React.FC<{ childDeviceDetails: any[]; parentDeviceId: string }> = (props) => {
    //const deviceDetails = useDeviceDetails();
    const starfishDeviceDetails = useStarfishDeviceDetails();
    const currentAppRoute = useCurrentAppRoute();
    const history = useHistory();
    //const isDeviceDetailEmpty = isDataLoaded(deviceDetails) ? deviceDetails.value.devices.length === 0 : false;
    const isChildDeviceDataEmpty = props.childDeviceDetails ? props.childDeviceDetails.length === 0 : false;
    // const parentDeviceIsEditable = isDataLoaded(starfishDeviceDetails) ? starfishDeviceDetails.value.isEditable : false;
    // const [childDeviceList, setChildDeviceList] = React.useState<Device[]>([]);
    // useEffect(() => {
    //     if (isDataLoaded(deviceDetails)) props.deviceDetails(deviceDetails.value);
    // }, [deviceDetails]); //eslint-disable-line react-hooks/exhaustive-deps


    const navigateToStarChildDevice = (): void => {

        if (currentAppRoute.type === 'StarfishDeviceProfile') {


            pushAppRoute(history, {
                type: 'AddStarFishChildDevice',
                deviceId: currentAppRoute.deviceId,
                locationId: currentAppRoute.locationId,
                orgId: currentAppRoute.orgId,
                siteId: currentAppRoute.siteId,

            });

        }

    };

    //const realTimeSiteData = useSignalRSiteData();
    const [childDeviceList, setChildDeviceList] = React.useState<StarfishDevice[]>([]);

    // React.useEffect(() => {
    //     if (isDataLoaded(deviceDetails) && deviceDetails.value.devices) {
    //         setChildDeviceList(deviceDetails.value.devices);
    //     }
    // }, [deviceDetails]);
    React.useEffect(() => {
        if (props.childDeviceDetails) {
            setChildDeviceList(props.childDeviceDetails);
        }
    }, [props.childDeviceDetails]);



    return (
        <>

            {isDataLoaded(starfishDeviceDetails) && starfishDeviceDetails.value.childDevices === null && (
                <Typography variant="h6" color="primary" style={{ marginBottom: 24 }}>
                    {`Devices (0)`}
                </Typography>
            )}
            <DataIndicators
                errorMessage="No Devices found"
                emptyMessage="No Devices found"
                data={starfishDeviceDetails}
                emptyIcon="Device"
                isEmpty={isChildDeviceDataEmpty}
                withAction={true}
                description="Devices that cannot connect directly to the Eaton Cloud can be added here. These Devices communicate with a Connected Device, which then connects to the Eaton Cloud."
                action={
                    // parentDeviceIsEditable ? (
                    <Button
                        startIcon={<AddIcon fontSize="large" style={{ color: 'white' }} />}
                        color="primary"
                        data-testid="add-child-device-button"
                        onClick={(): void => {
                            navigateToStarChildDevice();
                        }}
                        variant="contained"
                    >
                        Add Device
                    </Button>
                    // ) : (
                    //     <> </>
                    // )
                }
            />
            {isDataLoaded(starfishDeviceDetails) && (props.childDeviceDetails) &&
                props.childDeviceDetails.length > 0 &&
                currentAppRoute.type === 'StarfishDeviceProfile' && (
                    <>
                        <Box display="flex" justifyContent="space-between" style={{ padding: 16, paddingTop: 0 }}>
                            <Typography variant="h6" color="primary" data-testid="child-delete-count">
                                {`Devices (${props.childDeviceDetails.length})`}
                            </Typography>
                            {starfishDeviceDetails.value && (
                                <Button
                                    startIcon={<AddIcon fontSize="large" style={{ color: 'white' }} />}
                                    color="primary"
                                    data-testid="add-child-delete"
                                    onClick={(): void => {
                                        navigateToStarChildDevice();
                                    }}
                                    variant="contained"
                                >
                                    Add Device
                                </Button>
                            )}
                        </Box>
                        {isDataLoaded(starfishDeviceDetails) && childDeviceList && childDeviceList.length > 0 &&
                            < List data-testid="device-item">
                                {sortObjectArrayNaturally(childDeviceList, [{ sortField: 'name' }]).map(
                                    (device: StarfishDevice) => (
                                        <FlatListItem
                                            key={device.id}
                                            item={{
                                                id: device.id,
                                                name: device.name || '',
                                                status: device.status ? Status.Online : Status.Offline,
                                                type: 'StarfishChildDeviceProfile',
                                                isEditable: false,
                                                parentId: props.parentDeviceId || '',
                                            }}
                                            subTitleData={`${device.vendor} ${device.model}|${device.family}`}
                                            hasStatus={true}
                                            navigate={{
                                                type: 'StarfishChildDeviceProfile',
                                                deviceId: props.parentDeviceId,
                                                locationId: currentAppRoute.locationId,
                                                orgId: currentAppRoute.orgId,
                                                siteId: currentAppRoute.siteId,
                                                childDeviceId: device.id,
                                            }}
                                        ></FlatListItem>
                                    )
                                )}
                            </List>
                        }

                    </>
                )
            }
        </>
    );
};
